module.exports = __webpack_public_path__ + "assets/img/117@3x.b032fe20.png";